export default __webpack_public_path__ + "static/media/empty-messages.295a76e4.svg";